import { getLanguage } from "./dataProvider";
import {
  BranchReportModel,
  EmployeeReportModel,
  EnumEmployeeShiftState,
  EnumUserAcces,
  RawReportModel,
  ReportDetailModel,
  ShiftEmployeeEntries,
  ShiftLogModel,
  ShiftModel,
  ShiftPlanEmployee,
  ShiftPlanModel,
  UserModel,
} from "./dataStructures";
import { getCurrentCurrency } from "./profileManager";

import {
  convertServerToTimePickerString,
  formatDateToDDMMYYYY,
  formateDateTimeToServerDateString,
} from "./utilityFunctions";
import {
  fetchEmployeeReport,
  fetchListOfUsersForTeamLead,
  fetchReportDetail,
  fetchShiftLog,
  fetchShiftlogEntries,
  fetchShiftPlanForTeamLead,
  postLogEntry,
  postShiftlog,
  timeout,
  updateLogEntry,
} from "./wepApiManager";

export function calculateEmployeeElapsedTime(
  array_entries: ShiftEmployeeEntries[]
) {
  let totalSeconds: number = calculateTotalIntervalInSeconds(array_entries);
  totalSeconds = isNaN(totalSeconds) ? 0 : totalSeconds;
  const hrs: number = Math.trunc(totalSeconds / 3600);
  const mins: number = Math.trunc((totalSeconds - hrs * 3600) / 60);
  const remainingSeconds: number = totalSeconds - (hrs * 3600 + mins * 60);
  const isEnglish = getLanguage();
  const elapsedTime: string =
    (hrs > 0 ? hrs + (isEnglish ? " hrs : " : " Std : ") : "") +
    (mins > 0
      ? mins +
        (isEnglish ? " mins : " : " min : ") +
        remainingSeconds +
        (isEnglish ? " secs" : " sek")
      : remainingSeconds + (isEnglish ? " secs" : " sek"));
  return elapsedTime;
}

function subtractUntilDifference(a: String, b: String) {
  let i = 0;
  while (i < a.length && i < b.length && a[i] === b[i]) {
    i++;
  }
  return a.slice(0, i).trim(); // return matching prefix
}

export function calculateTotalIntervalInSeconds(
  array_entries: ShiftEmployeeEntries[]
) {
  let totalSeconds: number = 0;
  for (let i = 0; i < array_entries.length; i++) {
    const start: string = array_entries[i].start_time;
    let endTime: string =
      array_entries[i].end_time !== undefined
        ? (array_entries[i].end_time as string)
        : new Date().toUTCString();
    if (endTime === null || endTime === undefined) {
      endTime = new Date().toUTCString();
      endTime = start.slice(0, 17) + " 23:59:59 GMT";
    }
    let interval: number = (Date.parse(endTime) - Date.parse(start)) / 1000;
    interval = isNaN(interval) ? 0 : interval;
    totalSeconds = totalSeconds + interval;
  }
  return totalSeconds;
}

export function calculateEmployeeBreakTime(
  start_time: string,
  end_time: string | undefined,
  working_seconds: number
) {
  let et: string = "";
  if (end_time !== undefined) {
    et = end_time;
  }

  let overAllTimeInSecs: number = Date.parse(et) - Date.parse(start_time);
  /*
  if (overAllTimeInSecs === undefined || Number.isNaN(overAllTimeInSecs)) {
    overAllTimeInSecs = 0;
  }*/
  const isEnglish = getLanguage();
  if (Number.isNaN(overAllTimeInSecs)) {
    return isEnglish ? "Not Calculable" : "Nicht kalkulierbar";
  }
  let totalSeconds: number = overAllTimeInSecs / 1000 - working_seconds;

  const hrs: number = Math.trunc(totalSeconds / 3600);
  const mins: number = Math.trunc((totalSeconds - hrs * 3600) / 60);
  const remainingSeconds: number = totalSeconds - (hrs * 3600 + mins * 60);

  const elapsedTime: string =
    (hrs > 0 ? hrs + (isEnglish ? " hrs : " : " Std : ") : "") +
    (mins > 0
      ? mins +
        (isEnglish ? " mins : " : " min : ") +
        remainingSeconds +
        (isEnglish ? " secs" : " sek")
      : remainingSeconds + (isEnglish ? " secs" : " sek"));
  return elapsedTime;
}

export function calculateEmployeeEarning(
  intervalInSeconds: number,
  hourly_rate: number
) {
  const earning: number = (intervalInSeconds / 3600) * hourly_rate;

  return Math.round(earning * 100) / 100;
}

export function processAutofillSchedule(
  shift: ShiftModel,
  date: Date,
  array_branch_employees: UserModel[]
) {
  const weekday = ["sun", "mon", "tue", "wed", "thr", "fri", "sat"];
  const day: string = weekday[date.getDay()];

  let array_requiredEmployees: UserModel[] = [];
  for (let i = 0; i < array_branch_employees.length; i++) {
    const employee: UserModel = array_branch_employees[i];
    const pdIndex = employee.pref_time.findIndex((x) => x.day_key === day);
    if (employee.role.type === EnumUserAcces.TEAM_LEAD) {
      const tlIndex: number = array_requiredEmployees.findIndex(
        (x) => x.role.type === EnumUserAcces.TEAM_LEAD
      );
      if (tlIndex !== -1) {
        continue;
      }
    }
    if (pdIndex !== -1) {
      const stime = employee.pref_time[pdIndex].start_time;
      const etime = employee.pref_time[pdIndex].end_time;
      //if shift time is inside employee timing employee should be added.
      if (stime <= shift.start_time && etime >= shift.end_time) {
        array_requiredEmployees.push(employee);
      } else if (stime >= shift.start_time && stime <= shift.end_time) {
        array_requiredEmployees.push(employee);
      } else if (etime > shift.start_time && etime <= shift.end_time) {
        array_requiredEmployees.push(employee);
      }
      // if (
      //   stime !== undefined &&
      //   stime !== null &&
      //   stime !== "--:--" &&
      //   stime !== ""
      // ) {
      //   if (shift.start_time >= stime && stime < shift.end_time || etime>shift.end_time && etime<=shift.end_time) {
      //     if (etime !== undefined && etime !== "--:--") {
      //       array_requiredEmployees.push(employee);
      //     } else {
      //       array_requiredEmployees.push(employee);
      //     }
      //   }
      // }
    }
  }

  return array_requiredEmployees;
}

export function processGetTLShiftPlan(
  date: Date,
  user_id: string,
  callback: (shift_plan: ShiftPlanModel | undefined) => void,
  callback_firstOperation: (shift_plan: ShiftPlanModel | undefined) => void
) {
  fetchShiftPlanForTeamLead(
    date,
    user_id,
    (shift_plan: ShiftPlanModel | undefined) => {
      if (shift_plan !== undefined) {
        fetchListOfUsersForTeamLead(
          shift_plan,
          (shift_plan_v2: ShiftPlanModel) => {
            if (
              shift_plan_v2.log_id === undefined ||
              shift_plan_v2.log_id === "-1" ||
              shift_plan_v2.log_id === null
            ) {
              postShiftlog(shift_plan_v2, (log_Id: string) => {
                shift_plan_v2.log_id = log_Id;
                fetchShiftlogEntries(
                  shift_plan_v2.log_id,
                  (array_entries: ShiftEmployeeEntries[]) => {
                    callback_firstOperation(
                      addShiftEntriesToPlan(shift_plan_v2, array_entries)
                    );
                  }
                );
              });
            } else {
              fetchShiftLog(
                shift_plan_v2.log_id,
                (isSuccess: boolean, shift_log: ShiftLogModel) => {
                  if (isSuccess) {
                    let shift_plan_v3 = shift_plan_v2;
                    shift_plan_v3.log = shift_log;
                    fetchShiftlogEntries(
                      shift_plan_v3.log_id !== undefined
                        ? shift_plan_v3.log_id
                        : "",
                      (array_entries: ShiftEmployeeEntries[]) => {
                        callback(
                          addShiftEntriesToPlan(shift_plan_v3, array_entries)
                        );
                      }
                    );
                  }
                }
              );
            }
            //callback(shift_plan_v2);
          }
        );
      } else {
        callback(shift_plan);
      }
    }
  );
}

function addShiftEntriesToPlan(
  shift_plan: ShiftPlanModel,
  array_entries: ShiftEmployeeEntries[]
) {
  let tempShiftPlan = shift_plan;
  for (let i = 0; i < array_entries.length; i++) {
    const spIndex: number = tempShiftPlan.array_employees.findIndex(
      (x) => x.user.user_id === array_entries[i].user_id
    );
    if (spIndex !== -1) {
      const dupliIndex: number = tempShiftPlan.array_employees[
        spIndex
      ].array_shift_entries.findIndex(
        (x) => x.entry_id === array_entries[i].entry_id
      );
      if (dupliIndex === -1) {
        tempShiftPlan.array_employees[spIndex].array_shift_entries.push(
          array_entries[i]
        );
        const eIndex: number = tempShiftPlan.array_employees[
          spIndex
        ].array_shift_entries.findIndex(
          (x) =>
            x.end_time === null || x.end_time === undefined || x.end_time === ""
        );
        if (
          tempShiftPlan.array_employees[spIndex].array_shift_entries.length ===
          0
        ) {
          tempShiftPlan.array_employees[spIndex].current_state =
            EnumEmployeeShiftState.UNKNOWN;
        } else if (eIndex === -1) {
          const fIndex: number = tempShiftPlan.array_employees[
            spIndex
          ].array_shift_entries.findIndex(
            (x) =>
              x.ended_by_id !== null &&
              x.ended_by_id !== undefined &&
              x.ended_by_id !== ""
          );
          if (fIndex !== -1) {
            tempShiftPlan.array_employees[spIndex].current_state =
              EnumEmployeeShiftState.SHIFT_ENDED;
          } else {
            tempShiftPlan.array_employees[spIndex].current_state =
              EnumEmployeeShiftState.ON_BREAK;
          }
        } else {
          tempShiftPlan.array_employees[spIndex].current_state =
            EnumEmployeeShiftState.WORKING;
        }
      }
    }
  }

  return tempShiftPlan;
}

export async function processEmployeeShiftState(
  shift_employee: ShiftPlanEmployee,
  shift_log_id: string,
  callback: (isSuccess: boolean, newState: EnumEmployeeShiftState) => void
) {
  const user_id: string =
    shift_employee.user_id !== undefined ? shift_employee.user_id : "-1";
  const eIndex: number = shift_employee.array_shift_entries.findIndex(
    (x) => x.end_time === null || x.end_time === undefined || x.end_time === ""
  );
  if (eIndex === -1) {
    const start_at: Date = new Date();

    postLogEntry(
      user_id,
      shift_log_id,
      start_at,
      (isSuccess: boolean, entry_id: string) => {
        if (isSuccess) {
          let tempEmployee = shift_employee;
          const newEntry: ShiftEmployeeEntries = {
            user_id: user_id,
            shift_log_id: shift_log_id,
            start_time: formateDateTimeToServerDateString(start_at),
            entry_id: entry_id,
          };
          tempEmployee.array_shift_entries.push(newEntry);
          tempEmployee.current_state = EnumEmployeeShiftState.WORKING;
          callback(true, EnumEmployeeShiftState.WORKING);
        } else {
          callback(false, shift_employee.current_state);
        }
      }
    );
  } else {
    let entry = shift_employee.array_shift_entries[eIndex];
    //entry.ended_by_id = user_id;
    entry.end_time = formateDateTimeToServerDateString(new Date());
    updateLogEntry(entry, (isSuccess: boolean) => {
      if (isSuccess) {
        callback(true, EnumEmployeeShiftState.ON_BREAK);
      } else {
        callback(false, shift_employee.current_state);
      }
    });
  }
}

function processEndEmployeeShift(
  shift_employee: ShiftPlanEmployee,
  ended_by_id: string,
  callback: (isSuccess: boolean, newState: EnumEmployeeShiftState) => void
) {
  let entry =
    shift_employee.array_shift_entries[
      shift_employee.array_shift_entries.length - 1
    ];

  entry.ended_by_id = ended_by_id;
  if (
    entry.end_time === "-1" ||
    entry.end_time === null ||
    entry.end_time !== undefined ||
    entry.end_time !== ""
  ) {
    entry.end_time = formateDateTimeToServerDateString(new Date());
  }
  updateLogEntry(entry, (isSuccess: boolean) => {
    if (isSuccess) {
      callback(true, EnumEmployeeShiftState.SHIFT_ENDED);
    } else {
      callback(false, shift_employee.current_state);
    }
  });
}

export function processForceEndEmployeeShift(
  shift_employee: ShiftPlanEmployee,
  ended_by_id: string,
  shift_log_id: string,
  callback: (isSuccess: boolean, newState: EnumEmployeeShiftState) => void
) {
  let entry =
    shift_employee.array_shift_entries[
      shift_employee.array_shift_entries.length - 1
    ];
  if (entry === undefined) {
    const user_id =
      shift_employee.user_id !== undefined ? shift_employee.user_id : "-1";
    postLogEntry(
      user_id,
      shift_log_id,
      new Date(),
      (isSuccess: boolean, log_id: string) => {
        if (isSuccess) {
          callback(isSuccess, EnumEmployeeShiftState.SHIFT_ENDED);
        }
      },
      new Date(),
      ended_by_id
    );
  } else {
    processEndEmployeeShift(
      shift_employee,
      ended_by_id,
      (isSuccess: boolean, newState: EnumEmployeeShiftState) => {
        callback(isSuccess, newState);
      }
    );
  }
}

/* ********************** Branch manager ***************************** */

export function processGetReportDetail(
  shift_plan: ShiftPlanModel,
  callback: (
    shift_plan: ShiftPlanModel,
    array_reportDetail: ReportDetailModel[],
    total_hours: string
  ) => void
) {
  if (shift_plan.plan_id === undefined) {
    return;
  }

  fetchReportDetail(shift_plan.plan_id, (shift_plan: ShiftPlanModel) => {
    let array_reportsDetail: ReportDetailModel[] = [];
    let total_working_time: number = 0;

    if (shift_plan !== undefined) {
      for (let i = 0; i < shift_plan.array_employees.length; i++) {
        const employeeEle = shift_plan.array_employees[i];
        if (employeeEle.array_shift_entries.length > 0) {
          const working_seconds: number = calculateTotalIntervalInSeconds(
            employeeEle.array_shift_entries
          );
          total_working_time += working_seconds;
          const start_time: string =
            employeeEle.array_shift_entries[0].start_time;

          const end_time: string | undefined =
            employeeEle.array_shift_entries[
              employeeEle.array_shift_entries.length - 1
            ].end_time;

          const reportItem: ReportDetailModel = {
            user: employeeEle.user,
            start_time: convertServerToTimePickerString(
              returnEarliestDate(employeeEle.array_shift_entries)
            ),
            end_time: convertServerToTimePickerString(
              returnLatestDate(employeeEle.array_shift_entries)
            ),
            working_hours: calculateEmployeeElapsedTime(
              employeeEle.array_shift_entries
            ),
            break_hours: calculateEmployeeBreakTime(
              start_time,
              end_time,
              working_seconds
            ),
            earning: calculateEmployeeEarning(
              working_seconds,
              employeeEle.user.hourly_rate
            ).toFixed(2),
          };
          array_reportsDetail.push(reportItem);
        } else {
          const isEnglish = getLanguage();
          array_reportsDetail.push({
            user: employeeEle.user,
            start_time: isEnglish ? "Absent" : "Abwesend",
            end_time: isEnglish ? "Absent" : "Abwesend",
            working_hours: "0",
            break_hours: "0",
            earning: "0",
          });
        }
      }
    }
    const isEnglish = getLanguage();
    const hrs: number = Math.trunc(total_working_time / 3600);
    const mins: number = Math.trunc((total_working_time - hrs * 3600) / 60);
    const remainingSeconds: number =
      total_working_time - (hrs * 3600 + mins * 60);
    const elapsedTime: string =
      (hrs > 0 ? hrs + (isEnglish ? " hrs : " : " Std : ") : "") +
      (mins > 0
        ? mins +
          (isEnglish ? " mins : " : " min : ") +
          remainingSeconds +
          (isEnglish ? " secs" : " sek")
        : remainingSeconds + (isEnglish ? " secs" : " sek"));
    // const elapsedTime: string =
    //   (hrs > 0 ? hrs + " hrs : " : "") +
    //   (mins > 0
    //     ? mins + " mins : " + remainingSeconds + " secs"
    //     : remainingSeconds + " secs");
    callback(shift_plan, array_reportsDetail, elapsedTime);
  });
}

function returnEarliestDate(array_shiftEntries: ShiftEmployeeEntries[]) {
  if (array_shiftEntries.length === 0) {
    return "N/A";
  }

  let erDate: Date = new Date(array_shiftEntries[0].start_time);
  for (let i = 0; i < array_shiftEntries.length; i++) {
    const compDate: Date = new Date(array_shiftEntries[i].start_time);
    if (erDate > compDate) {
      erDate = compDate;
    }
  }

  return erDate.toTimeString();
}

function returnLatestDate(array_shiftEntries: ShiftEmployeeEntries[]) {
  if (array_shiftEntries.length === 0) {
    return "N/A";
  }

  let erDate: Date = new Date(
    array_shiftEntries[0].end_time !== undefined
      ? array_shiftEntries[0].end_time
      : ""
  );
  for (let i = 0; i < array_shiftEntries.length; i++) {
    if (array_shiftEntries[i].end_time === undefined) {
      continue;
    }
    const endTime: string = array_shiftEntries[i].end_time as string;
    const compDate: Date = new Date(endTime);
    if (erDate < compDate) {
      erDate = compDate;
    }
  }

  return erDate.toTimeString();
}

/* ******************************************** admin  **************************** */
export function processCSVReportForAdmin(
  array_reportDetail: ReportDetailModel[],
  date: string,
  branch: string,
  total_hours: string,
  comments: string
) {
  let reportTextEng: string =
    "Date," +
    date +
    "\nBranch," +
    branch +
    "\nTotal Hours," +
    total_hours +
    "\n";
  reportTextEng += "Comments : " + comments.replaceAll(",", "/,") + "\n\n";
  reportTextEng +=
    "Name,Employee ID, Start Time , End Time ,Total Working Hours \n";

  let reportTextGerman: string =
    "Datum," +
    date +
    "\nFiliale," +
    branch +
    "\nGesamtstunden," +
    total_hours +
    "\n";
  reportTextGerman +=
    "Bemerkungen : " + comments.replaceAll(",", "/,") + "\n\n";
  reportTextGerman +=
    "Name,Mitarbeiter ID, Arbeitsbeginn , Arbeitsende , Summe \n";

  const isEnglish = getLanguage();
  let reportText: string = isEnglish ? reportTextEng : reportTextGerman;
  for (let i = 0; i < array_reportDetail.length; i++) {
    const item: ReportDetailModel = array_reportDetail[i];
    const user: string =
      item.user.first_name +
      " " +
      item.user.last_name +
      "," +
      item.user.employee_id;
    const row =
      user +
      "," +
      item.start_time +
      "," +
      item.end_time +
      "," +
      item.working_hours;
    reportText = reportText + row + "\n";
  }
  return reportText;
}

export function processEmployeeCSVReportForAdmin(
  array_reports: EmployeeReportModel[],
  start_date: string,
  end_date: string
) {
  let temp_hours: number = 0;
  let total_earning: number = 0;
  for (let i = 0; i < array_reports.length; i++) {
    temp_hours += array_reports[i].total_time_in_seconds;
    total_earning += array_reports[i].total_earning;
  }

  let totalSeconds: number = temp_hours;
  const hrs: number = Math.trunc(totalSeconds / 3600);
  const mins: number = Math.trunc((totalSeconds - hrs * 3600) / 60);
  const remainingSeconds: number = totalSeconds - (hrs * 3600 + mins * 60);
  const isEnglish = getLanguage();
  // const total_hours: string =
  //   (hrs > 0 ? hrs + " hrs : " : "") +
  //   (mins > 0
  //     ? mins + " mins : " + remainingSeconds + " secs"
  //     : remainingSeconds + " secs");
  const total_hours: string =
    (hrs > 0 ? hrs + (isEnglish ? " hrs : " : " Std : ") : "") +
    (mins > 0
      ? mins +
        (isEnglish ? " mins : " : " min : ") +
        remainingSeconds +
        (isEnglish ? " secs" : " sek")
      : remainingSeconds + (isEnglish ? " secs" : " sek"));

  let reportTextEng =
    "Report Start Date," +
    start_date +
    "\nReport End Date," +
    end_date +
    "\nTotal Hours," +
    total_hours +
    "\nTotal Salary," +
    total_earning.toFixed(0) +
    "\n\n";
  reportTextEng +=
    "Name,Employee ID ,Total Working Hours,Salary(" +
    getCurrentCurrency() +
    ") \n";
  let reportTextGerman: string =
    "Startdatum des Berichts," +
    start_date +
    "\nEnddatum des Berichts," +
    end_date +
    "\nGesamtstunden," +
    total_hours +
    "\nGesamtgehalt," +
    total_earning.toFixed(0) +
    "\n\n";
  reportTextGerman +=
    "Name,Mitarbeiter-ID ,Gesamtarbeitszeit,Gehalt(" +
    getCurrentCurrency() +
    ") \n";
  let reportText = isEnglish ? reportTextEng : reportTextGerman;
  for (let i = 0; i < array_reports.length; i++) {
    const item: EmployeeReportModel = array_reports[i];
    const user: string =
      item.user.first_name +
      " " +
      item.user.last_name +
      "," +
      (item.user.employee_id === null || item.user.employee_id === undefined
        ? isEnglish
          ? "Not Available"
          : "Nicht verfügbar"
        : item.user.employee_id);
    const row =
      user +
      "," +
      item.working_hours +
      "," +
      item.total_earning.toFixed() +
      "," +
      item.working_hours;
    reportText = reportText + row + "\n";
  }
  return reportText;
}

export function processBranchCSVReportForAdmin(
  array_reports: BranchReportModel[],
  start_date: string,
  end_date: string
) {
  let reportTextEng: string =
    "Report Start Date," +
    start_date +
    "\nReport End Date," +
    end_date +
    "\n\n";
  reportTextEng += "Branch,Total Working Hours \n\n";
  let reportTextGerman: string =
    "Startdatum des Berichts," +
    start_date +
    "\nEnddatum des Berichts," +
    end_date +
    "\n\n";
  reportTextGerman += "Filiale,Gesamtstunden \n\n";
  const isEnglish = getLanguage();
  let reportText: string = isEnglish ? reportTextEng : reportTextGerman;

  for (let i = 0; i < array_reports.length; i++) {
    const item: BranchReportModel = array_reports[i];
    const row = item.branch.name + "," + item.working_hours;
    reportText = reportText + row + "\n";
  }
  return reportText;
}

export function processEmployeeRawReportForAdmin(
  startDate: Date,
  endDate: Date,
  callback: (array_reports: RawReportModel[]) => void
) {
  fetchEmployeeReport(
    startDate,
    endDate,
    (array_items: EmployeeReportModel[]) => {
      let array_reports: RawReportModel[] = [];
      for (let i = 0; i < array_items.length; i++) {
        const item = array_items[i];
        for (let j = 0; j < item.array_logEntries.length; j++) {
          const entry = item.array_logEntries[j];
          let timeinsecs: number = calculateTotalIntervalInSeconds([entry]);
          timeinsecs = isNaN(timeinsecs) ? 0 : timeinsecs;
          let endTime = entry.end_time;
          if (endTime === null || endTime === undefined) {
            endTime = new Date().toUTCString();
            endTime = endTime.slice(0, 17) + " 23:59:59 GMT";
          }
          let branch_name: string =
            entry.branch_name !== undefined ? entry.branch_name : "N/A";
          array_reports.push({
            user: item.user,
            entry: entry,
            date: formatDateToDDMMYYYY(entry.start_time.slice(0, 17)),
            branch: branch_name,
            start_time: entry.start_time.slice(17, 30),
            end_time: endTime.slice(17, 30),
            total_time: calculateEmployeeElapsedTime([entry]),
          });
        }
      }
      callback(array_reports);
    }
  );
}

export function processRawCSVReportForAdmin(
  array_reports: RawReportModel[],
  start_date: string,
  end_date: string
) {
  let reportTextEng: string =
    "Report Start Date," +
    start_date +
    "\nReport End Date," +
    end_date +
    "\n\n";
  reportTextEng +=
    "Date , Employee ID , Employee Name , Start Time , End Time , Total Time , Branch Name , Hourly Rate \n\n";
  let reportTextGerman: string =
    "Startdatum des Berichts," +
    start_date +
    "\nEnddatum des Berichts," +
    end_date +
    "\n\n";
  reportTextGerman +=
    "Datum , Mitarbeiter-ID , Mitarbeitername , Startzeit , Endzeit , Gesamtzeit , Filialname , Stundenlohn\n\n";
  const isEnglish = getLanguage();
  let reportText: string = isEnglish ? reportTextEng : reportTextGerman;

  for (let i = 0; i < array_reports.length; i++) {
    const item: RawReportModel = array_reports[i];
    const row =
      item.date.replace(",", " ") +
      "," +
      (item.user.employee_id ? item.user.employee_id : "Not Available") +
      "," +
      item.user.first_name +
      " " +
      item.user.last_name +
      "," +
      item.start_time +
      "," +
      item.end_time +
      "," +
      item.total_time +
      "," +
      item.branch +
      "," +
      item.user.hourly_rate;
    reportText = reportText + row + "\n";
  }
  return reportText;
}

export async function processDownloadReport() {
  await timeout(1000);
  return true;
}
